import { Controller } from '@hotwired/stimulus'
import { copyToClipboard } from '@/lib/http'

// Copy-to-clipboard for admin invite links (invite-gate epic, U6). Progressive
// enhancement: the link URL rides a data value, so the button is inert without
// JS. On click it copies the URL and swaps the label to a "¡Copiada!"
// confirmation for ~2s (mirrors useCopyFeedback), announced via aria-live.
// Reuses the shared copyToClipboard, which already covers the insecure dev
// origin (http://app.lvh.me:3000 has no navigator.clipboard).
export default class extends Controller<HTMLButtonElement> {
  static values = { text: String, copiedLabel: String }

  declare readonly textValue: string
  declare readonly copiedLabelValue: string

  private restingLabel = ''
  private timer: number | undefined

  connect() {
    // Sync marker so a system test can wait until the handler is wired before
    // clicking (same pattern as auth_form / confirm controllers).
    this.element.setAttribute(`data-${this.identifier}-ready`, 'true')
  }

  disconnect() {
    window.clearTimeout(this.timer)
  }

  async copy(event: Event) {
    event.preventDefault()
    const ok = await copyToClipboard(this.textValue)
    if (!ok) return
    if (!this.restingLabel) this.restingLabel = this.element.textContent ?? ''
    this.element.textContent = this.copiedLabelValue
    window.clearTimeout(this.timer)
    this.timer = window.setTimeout(() => {
      this.element.textContent = this.restingLabel
    }, 2000)
  }
}
